import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ButtonComponent } from '@personal-area/global/ui'
import { CardWrapperModule } from '@personal-area/global/ui';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

import { IconSpriteModule } from '@personal-area/icon-sprite';

import { IdentityVerificationFacade } from '../../../state/facades/identity';

@Component({
  templateUrl: './identity-banned.component.html',
  styleUrls: ['./identity-banned.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CardWrapperModule,
    ButtonComponent,
    IconSpriteModule,
    TranslateModule,
    RouterModule,
    AsyncPipe,
  ],
})
export class IdentityBannedComponent {
  public banReason$: Observable<string>;

  constructor(identityVerificationFacade: IdentityVerificationFacade) {
    this.banReason$ = identityVerificationFacade.rejectReason$;
  }
}
